import React from 'react'
import Complete from './complete'
import Warning from './warning.jsx'

const Upshot = props => {
    let { status, subscribeData, subscribeInfo, additionalData = {} } = props

    switch (status) {
        case 'complete':
            return (
                <Complete subscribeData={subscribeData} subscribeInfo={subscribeInfo} />
            )
            break
        case 'warning':
            return (
                <Warning
                    subscribeData={subscribeData}
                    subscribeInfo={subscribeInfo}
                    additionalData={additionalData}
                />
            )
            break
    }
}

export default Upshot
